import { render, staticRenderFns } from "./Brick.vue?vue&type=template&id=1b3555bd&"
import script from "./Brick.vue?vue&type=script&lang=ts&"
export * from "./Brick.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports